import React from 'react';
import PropTypes from 'prop-types';

export const PriceText = ({ children, ...props }) => {
    return (
        <span
            style={{
                fontFamily: 'Inter',
                fontSize: '18px',
                color: 'black',
                fontWeight: '400'
            }}
            {...props}
        >
            {children}
        </span>
    );
};

export const DurationText = ({ children, ...props }) => {
    return (
        <span
            style={{
                fontFamily: 'Inter',
                fontWeight: '500',
                fontSize: '16px',
                lineHeight: '24px',
                color: '#727272',
                margin: '0',
                padding: '0',
                display: 'inline-block'
            }}
            {...props}
        >
            {children}
        </span>
    );
};

export const DurationContainer = ({ children, ...props }) => {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
            }}
            {...props}
        >
            {children}
        </div>
    );
};

export const ClockIcon = ({ ...props }) => {
    return (
        <img
            src="/icons/clock.svg"
            alt="Duration"
            style={{
                width: '24px',
                height: '24px',
                display: 'block'
            }}
            {...props}
        />
    );
};

export const PriceChevronContainer = ({ children, ...props }) => {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                minHeight: '60px'
            }}
            {...props}
        >
            {children}
        </div>
    );
};

export const ChevronIcon = ({ ...props }) => {
    return (
        <img
            src="/icons/chevron.svg"
            alt="Chevron"
            style={{
                width: '6px',
                height: '12px',
                marginLeft: '16px'
            }}
            {...props}
        />
    );
};

PriceText.propTypes = {
    children: PropTypes.node.isRequired
};

DurationText.propTypes = {
    children: PropTypes.node.isRequired
};

DurationContainer.propTypes = {
    children: PropTypes.node.isRequired
};

PriceChevronContainer.propTypes = {
    children: PropTypes.node.isRequired
};
